<template>
	<div class="sf-flex-column">
		<div class="sf-col sf-col-4">
			<sf-card class="p-0 card_bg">
				<search-bar :scrId="scrId" />
			</sf-card>
		</div>
		<div class="sf-col sf-col-20">
			<notification-table :scrId="scrId" />
		</div>
	</div>
</template>

<script>
import SearchBar from './Search/SearchBar';
import NotificationTable from './Table/NotificationTable';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { SearchBar, NotificationTable }
};
</script>

<style></style>
